import React, { Component } from 'react';
import {
  HelpOutline,
  SupervisorAccount,
  Timeline,
  Chat,
  MailOutline,
  Phone,
  InsertDriveFile,
  LaptopChromebook,
  DirectionsWalk,
  LocalLibrary,
  BusinessCenter,
  School
} from '@mui/icons-material';
import { getHamburgerLinks } from '../../services/reservoir';
import { connect } from 'react-redux';

const getLinkIcon = iconType => {
  switch (iconType) {
    case 'ActionHelpOutline':
      return <HelpOutline className="btn-point-events" />;
    case 'ActionSupervisorAccount':
      return <SupervisorAccount className="btn-point-events" />;
    case 'ActionTimeline':
      return <Timeline className="btn-point-events" />;
    case 'HardwareLaptopChromebook':
      return <LaptopChromebook className="btn-point-events" />;
    case 'PlacesBusinessCenter':
      return <BusinessCenter className="btn-point-events" />;
    case 'MapsDirectionsWalk':
      return <DirectionsWalk className="btn-point-events" />;
    case 'MapsLocalLibrary':
      return <LocalLibrary className="btn-point-events" />;
    case 'CommunicationPhone':
      return <Phone className="btn-point-events" />;
    case 'CommunicationChat':
      return <Chat className="btn-point-events" />;
    case 'CommunicationMailOutline':
      return <MailOutline className="btn-point-events" />;
    case 'EditorInsertDriveFile':
      return <InsertDriveFile className="btn-point-events" />;
    default:
      return <School className="btn-point-events" />;
  }
};

const buildClass = (baseClass, title) => {
  let titleLocal = title.replace('&', '');
  return [baseClass, titleLocal.split(' ').join('-')].join(' ');
};

const buildLink = attributes => {
  const handleHamburgerMenuLinkClick = event => {
    window.dataLayer.push({
      event: 'custom.menu.click',
      label: attributes.field_hamburger_link.title,
      group: attributes.field_contact_link ? 'Contact VU' : 'Useful Links',
      info: {
        url: attributes.field_hamburger_link.uri,
        id: attributes.uuid,
        location: 'Hamburger Menu'
      }
    });

    if (
      attributes.field_hamburger_link &&
      attributes.field_hamburger_link.onclick
    ) {
      attributes.field_hamburger_link.onclick();
    }
  };

  return (
    <a
      key={attributes.drupal_internal__vid}
      className={buildClass('link-container', attributes.field_hamburger_link.title)}
      href={attributes.field_hamburger_link.uri}
      disabled={attributes.isDisabled}
      onClick={handleHamburgerMenuLinkClick}
    >
      <div className="link-icon btn-point-events">
        {getLinkIcon(attributes.field_icon_svg)}
      </div>
      <div className="link-txt">{attributes.field_hamburger_link.title}</div>
    </a>
  );
};

const mapStateToProps = ({ courses: { selectedCourseCode, data }, course: { selectedCourse } }) => {
  return {
    admissionCategory: selectedCourse.admissionCategory,
    locationCode: selectedCourse.locationCd
  };
};

class UsefulLinks extends Component {
  constructor(props) {
    super(props);

    this.state = {
      usefulLinks: [],
      chatStates: [
        {
          text: '',
          wait: 0,
          available: 1
        },
        {
          text: '',
          available: 0,
          wait: 1
        },
        {
          text: "We're sorry, chat is currently unavailable.",
          outOfHours: true
        }
      ],
      chatStateText: "We're sorry, chat is currently unavailable.",
      loadSubscribe: false,
      chatActive: false
    };
  }

  componentDidMount() {
    this.initialiseHamburgerLinks();

    try {
      if (window.RightNow.Client.Event.evt_dataRequest) {
        this.subscribeToEvents();
      }
    } catch (e) {
      let timeoutID = window.setTimeout(this.subscribeToEvents, 2000);
      this.setState({
        loadSubscribe: timeoutID
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.admissionCategory !== prevProps.admissionCategory ||
      this.props.locationCode !== prevProps.locationCode
    ) {
      this.initialiseHamburgerLinks();
    }
  }

  initialiseHamburgerLinks(eventType, args, instance) {
    //console.log('data from event update %o args %o instance %o', eventType, args, instance)

    if (args && typeof args === 'object') {
      //console.log('if block %o args %o this.state %o', eventType, args[0].data.stats, instance.state)
      instance.updateChatState(args, instance);
    }

    getHamburgerLinks(
      this.props.admissionCategory,
      this.props.locationCode
    ).then(hamburgerLinks => {
      this.setState({
        usefulLinks: hamburgerLinks.filter(
          item => item.attributes.field_hamburger_link
        )
      });
    });
  }

  updateChatState = (updateResult, instance) => {
    let currState = updateResult[0].data.stats;
    let chatActive = true;
    let foundState = instance.state.chatStates.find(item => {
      if (currState.out_of_hours) {
        chatActive = false;
        return true;
      } else if (
        parseInt(currState.availableSessionCount, 10) >= item.available &&
        parseInt(currState.expectedWaitSeconds, 10) === item.wait
      ) {
        return true;
      } else if (
        parseInt(currState.availableSessionCount, 10) >= item.available &&
        parseInt(currState.expectedWaitSeconds, 10) >= item.wait
      ) {
        return true;
      }

      return false;
    });

    //console.log('foundState %o  currState %o', foundState, currState)

    if (foundState) {
      instance.setState({
        chatStateText: foundState.text,
        chatActive: chatActive
      });
    }
  };

  subscribeToEvents = () => {
    if (window.RightNow.Client.Event.evt_dataRequest) {
      window.RightNow.Client.Event.evt_conditionalChatLinkAvailabilityResponse.subscribe(
        this.initialiseHamburgerLinks,
        this
      );

      let timeoutID = this.state.timeoutID;
      this.setState(
        {
          loadSubscribe: true
        },
        function(timeoutID) {
          window.clearTimeout(timeoutID);
        }
      );
    }
  };

  getUsefulLinks = () => {
    return this.state.usefulLinks.filter(
      item => !item.attributes.field_contact_link
    );
  };

  getContactVULinks = () => {
    return this.state.usefulLinks.filter(
      item => item.attributes.field_contact_link
    );
  };

  render() {
    return (
      <div>
        {this.getUsefulLinks().length > 0 ? (
          <div className="slidein__subsection">
            <h3 className="slidein__section-subheading">Useful Links</h3>
            <div className="slidein__linkout">
              {this.getUsefulLinks().map(item => buildLink(item.attributes))}
            </div>
          </div>
        ) : null}
        {this.getContactVULinks().length > 0 ? (
          <div>
            <div className="slidein__subsection">
              <h3 className="slidein__section-subheading">Contact VU</h3>
              <div className="slidein__linkout">
                {this.getContactVULinks().map(item => {
                  if (
                    item.attributes.field_contact_link &&
                    item.attributes.field_chat_link &&
                    this.state.loadSubscribe === true
                  ) {
                    if (!this.state.chatActive) {
                      item.attributes.isDisabled = !this.state.chatActive;
                      item.attributes.field_hamburger_link.uri =
                        item.attributes.field_hamburger_link.uri_default;
                    } else if (
                      document.getElementById('rn_sccl_0_Link') !== null
                    ) {
                      item.attributes.field_hamburger_link.uri_default =
                        item.attributes.field_hamburger_link.uri;
                      item.attributes.field_hamburger_link.uri =
                        'javascript:void(0);';
                      item.attributes.field_hamburger_link.onclick = document.getElementById(
                        'rn_sccl_0_Link'
                      ).onclick;
                      item.attributes.isDisabled = false;
                    }
                  }

                  return buildLink(item.attributes);
                })}
              </div>
            </div>
            {this.getContactVULinks().some(
              ({ attributes }) =>
                attributes.field_contact_link && attributes.field_chat_link
            ) && (
              <div className="chatStatusText">
                <p>{this.state.chatStateText}</p>
              </div>
            )}
          </div>
        ) : null}
      </div>
    );
  }
}

export default connect(mapStateToProps)(UsefulLinks);
